import { createIcon } from '../create-icon'

export const GameCrosshair = createIcon('GameCrosshair', ({ strokeWidth }) => (
  <>
    <circle cx="12" cy="12" r="9" strokeWidth={strokeWidth} />
    <circle cx="12" cy="12" r="4" strokeWidth={strokeWidth} />
    <line x1="12" y1="1" x2="12" y2="5" strokeWidth={strokeWidth} />
    <line x1="12" y1="19" x2="12" y2="23" strokeWidth={strokeWidth} />
    <line x1="1" y1="12" x2="5" y2="12" strokeWidth={strokeWidth} />
    <line x1="19" y1="12" x2="23" y2="12" strokeWidth={strokeWidth} />
  </>
))
